import Layout from "Layout";
import NonAuthLayout from "Layout/NonAuthLayout";
import React from "react";
import { Route, Routes } from "react-router-dom";

//routes
import { AuthProtected } from "./AuthProtected";
import { authProtectedRoutes, publicRoutes } from "./RoutesConfig";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={<NonAuthLayout> {route.component} </NonAuthLayout>}
            />
          ))}
        </Route>

        <Route>
          {authProtectedRoutes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <AuthProtected permissions={route?.permissions}>
                  <Layout>{route.component}</Layout>{" "}
                </AuthProtected>
              }
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
